import ColorPicker from 'bee-colorpicker'

export default ColorPicker
